<template>
    <div>
        <figure class="tourFigure" id="triggerFigure">
            <div v-if="!showInfo">
                <div class="gradient-box"></div>
                <div class="line-item">
                    <div class="left-item">
                        <md-button title="Back to Triggers" class="md-icon-button" @click="returnToPrevious" aria-label="Back">
                            <md-icon>arrow_back</md-icon>
                        </md-button>
                    </div>
                    <div class="left-item" style="position: fixed;margin-left: 3%;">
                        <h3 class="link" @click="toggleInfoBlock('EDITOPEN')">{{ currentTrigger.name }}</h3>
                    </div>
                </div>
            </div>
            <div class="info-block" v-if="showInfo">
                <h3>
                    <textarea maxlength="60" rows="1" v-model="currentTrigger.name"></textarea>
                </h3>
                <md-button class="md-icon-button close-info" @click="toggleInfoBlock('EDITCLOSE')">
                    <md-icon>close</md-icon>
                </md-button>
                <md-button class="save-button md-raised md-primary" @click="saveTriggerNameOnly">Save</md-button>
            </div>
        </figure>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import {saveTrigger, updateTriggerName} from '../../services/EditorService.js';

export default {
  data: () => ({
    showInfo: false,
    editTourName: ''
  }),
  computed: {
    ...mapGetters('triggers', ['currentTrigger', 'initialTrigger'])
  },
  methods: {
    ...mapActions('editor', ['toggleShowTriggerTabs']),
    toggleInfoBlock (editOpenClose) {
      if (editOpenClose === 'EDITOPEN') {
        this.editTourName = this.currentTrigger.name;
      }
      if (editOpenClose === 'EDITCLOSE') {
        this.currentTrigger.name = this.editTourName;
      }
      this.showInfo = !this.showInfo;
    },
    returnToPrevious () {
      this.toggleShowTriggerTabs(false);
      this.$router.push('/tour/topic');
    },
    async saveTriggerName () {
      let triggerToSave = Object.assign({}, this.initialTrigger);
      triggerToSave.name = this.currentTrigger.name;
      triggerToSave.latLng = JSON.stringify(triggerToSave.latLng);
      await saveTrigger(triggerToSave)
        .then(response => {
          this.toggleInfoBlock('SAVECLOSE');
        })
        .catch(error => {
          console.log(error.response.data);
        });
    },
    async saveTriggerNameOnly () {
      let triggerToSave = Object.assign({}, this.initialTrigger);
      triggerToSave.name = this.currentTrigger.name;
      await updateTriggerName(triggerToSave)
        .then(response => {
          this.toggleInfoBlock('SAVECLOSE');
        })
        .catch(error => {
          console.log(error.response.data);
        });
    }
  }
};
</script>
<style lang="scss">
.info-block .save-button {
    bottom: 20px;
}

#triggerFigure .save-button {
    top: 93px;
}
</style>



// WEBPACK FOOTER //
// src/components/tour/TriggerFigure.vue